import React from "react";
import BusinessImage from "../../../assets/image/businessFuture.svg";
import { sheduleLink } from "../../../constant/Constant";

const PricingBanner = () => {
  return (
    <section className="w-full my-12 md:my-28 px-10">
      <div className="relative mt-8 md:mt-20 rounded-3xl overflow-hidden h-[22rem] xl:h-[22rem] bg-black">
        <div className="w-full h-full flex z-[1] items-center px-12 py-6">
          <div className="w-9/12 relative">
            <div className="space-y-3 bg-white max-w-[708px] max-h-[300px] px-6 py-4 rounded-3xl">
              <div className="w-full text-[24px] font-Outfit font-semibold text-black">
                Second thoughts? Don’t worry!
              </div>
              <div class="font-Outfit font-bold text-[36px]   text-black max-w-full lg:max-w-[600px] w-full text-center lg:text-left">
                Here's your <span className={"text-teal-400"}>30-day </span>
                money-back guarantee!
              </div>
              <div className="w-full text-[24px] font-Outfit font-normal text-black">
                Choose SuccessionNow for streamlined, cost-effective succession
                planning. If it doesn't meet expectations in 30 days, get a
                no-questions-asked refund.
              </div>
            </div>
          </div>
          <div className=" w-3/12  relative">
            <div className="relative flex justify-center">
              <div className="w-[175px] h-[175px] rounded-xl]">
                <div className="w-full h-full rounded-xl overflow-hidden bg-white [clip-path:polygon(50%_0%,93%_25%,93%_75%,50%_100%,7%_75%,7%_25%)]">
                  <img
                    src="https://s3-alpha-sig.figma.com/img/3d30/e61b/d2d98ea92628ddd9656c957514f913d5?Expires=1745193600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=Vhm7TKTm~nvHZz16fwdBDGW7EyFBJKu3-i8EnPXTbwmstehDaUDBnSXKz8SMGjNRLDD0UzUd24IWM7-gOGn-QVNkGfuTkvpm37lfBcTXqjjciHQcR4SwwHqT3QAtoY0-wY7d~2AZgJ7R9jkvqVwEI6~D0LWPQAAy2Fw933J1M5mje7FA2rBa2AyOcw2sNJHXoPhLqkph9rAzBt-oKb6pF0-y0yvdW~PSH2c2bdOhYs0J29miLZI9XN0lCbGhdWUwhe-3IR1EFZzMDevMcZMZgkoIbnHj5xJyzzenKjYz2Jec8PfPyb3UI8KlC5H71trnquQ1hpAfSEhzV-2A7VnP6A__"
                    alt="alt"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
            <div className="w-[244px] mx-auto mt-14">
              <a
                target="_blank"
                href={sheduleLink}
                className={
                  "relative z-0 overflow-hidden flex justify-center items-center gap-2 rounded-full h-[52px] py-0 px-3 transition-all duration-200 border-black text-black border after:absolute after:h-full after:content-[''] after:-z-[1] after:top-0 after:left-0 after:transition-[width] after:duration-300 after:ease-in-out after:w-full hover:after:w-0 mx-auto bg-[#55BDB3] after:bg-transparent hover:border-black hover:text-black capitalize font-IBM font-medium text-base mt-5"
                }
              >
                Let’s Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingBanner;
